<template>
	<div>
		<div class="row">
			<div class="col-12">
				<g-table-sync
					:app="app"
					:view="view"
					pagination="loadmore"
					:default-limit="12"
					:default-filters="filters"
					:columns="columns"
				>
					<template
						slot="empresa"
						slot-scope="item"
					>
						<small>{{ item.EmpresaNombre }}</small>
					</template>

					<template
						slot="importe"
						slot-scope="item"
					>
						{{ item.PresupuestoTotal }} €
					</template>

					<template
						slot="estado"
						slot-scope="item"
					>
						<budget-status
							:data="item"
							class="float-right"
						/>
					</template>

					<template
						slot="pdf"
						slot-scope="item"
					>
						<g-upload
							accept=".pdf"
							name="PresupuestoPDF"
							size="small"
							app="presupuestos"
							class="mr-2"
							:item="item._EntityId"
							:file-name="'presupuesto_'+item._EntityId+'.pdf'"
							:folder-name="'presupuestos'"
							:value="item.PresupuestoPDF"
						/>
					</template>

					<template
						slot="actions"
						slot-scope="item"
					>
						<g-item-actions
							:app="app"
							:item="item"
							:disabled="itemWorking.id === item._EntityId"
							mode="dropdown"
							@edit="$router.push({name: 'presupuestos_edit', params: {id: $event._EntityId}})"
						>
							<template slot="text">
								<a-button :loading="itemWorking.id === item._EntityId">
									{{ itemWorking.id === item._EntityId ? itemWorking.text : 'Acciones' }}
								</a-button>
							</template>

							<template slot="top">
								<!-- Enviar email -->
								<a-menu-item
									v-if="item.PresupuestoPDF"
									key="2"
									:disabled="itemWorking.id === item._EntityId"
									@click="mailerScope = item"
								>
									<fa-icon
										:icon="['far','paper-plane']"
										class="mr-2"
									/> Enviar email
								</a-menu-item>

								<!-- Crear PDF -->
								<a-menu-item
									key="0"
									:disabled="itemWorking.id === item._EntityId"
								>
									<a-popconfirm
										v-if="$gestios.items('presupuestos').auth({
											scopes: [`set.mine`, `set`],
											strict: false,
											item
										})"
										title="¿Se regenerará el PDF del presupuesto. ¿Estas seguro?"
										@confirm="() => createPDF(item)"
									>
										<fa-icon
											:icon="['fas','file-pdf']"
											class="mr-2"
										/>
										Generar PDF
									</a-popconfirm>
								</a-menu-item>

								<!-- Crear factura -->
								<a-menu-item
									key="1"
									:disabled="itemWorking.id === item._EntityId"
								>
									<a-popconfirm
										title="Se creará una factura en base al presupuesto. ¿Estas seguro?"
										@confirm="() => createInvoice(item)"
									>
										<fa-icon
											:icon="['fas','file-invoice']"
											class="mr-2"
										/> Convertir a factura
									</a-popconfirm>
								</a-menu-item>
							</template>
						</g-item-actions>
					</template>

					<template
						slot="email"
						slot-scope="item"
					>
						<g-email :value="item" />
					</template>
				</g-table-sync>
			</div>
		</div>

		<mailer
			:item="mailerScope"
			:view="view"
			@close="mailerScope = null"
		/>
	</div>
</template>

<script>
import mailer from './mailer';
import presupuestosMX from '../../helpers/presupuestos';

export default {
	name: 'PesupuestosList',
	components: {
		mailer
	},
	data() {
		return {
			app: 'presupuestos',
			view: 'presupuestosList',
			itemWorking: {
				id: null,
				text: ''
			},
			mailerScope: null,
			columns: [
				{
					title: 'ID',
					index: '_EntityId',
					order: true,
					search: true,
					width: '80px'
				},
				{
					title: 'Empresa',
					index: 'EmpresaNombre',
					slot: 'empresa',
					search: true
				},
				{
					title: 'Importe',
					index: 'PresupuestoTotal',
					slot: 'importe',
					order: true,
					search: true,
					width: '150px'
				},
				{
					title: 'Fecha',
					index: 'PresupuestoFecha',
					slot: '_date',
					order: true,
					search: false
				},
				{
					title: 'Email',
					index: 'Email',
					slot: '_email'
				},
				{
					title: 'PDF',
					index: 'PresupuestoPDF',
					slot: 'pdf'
				},
				{
					title: 'Estado',
					align: 'right',
					index: 'PresupuestoEstado',
					slot: 'estado',
					filters: [
						{
							text: 'Pendiente',
							value: '0'
						},
						{
							text: 'Aprobado',
							value: '1'
						},
						{
							text: 'Rechazado',
							value: '2'
						}
					]
				},
				{
					title: ' ',
					slot: 'actions',
					align: 'right'
				}
			]
		};
	},
	computed: {
		empresa() {
			return this.$route.query.empresa || 0;
		},
		filters() {
			if (this.empresa > 0) {
				return [{
					field: 'Empresa',
					type: 'number',
					value: this.empresa,
					lig: '='
				}];
			}

			return [];
		}
	},
	methods: {
		async createInvoice(item) {
			if (this.itemWorking.id === null) {
				this.itemWorking = {
					id: item._EntityId,
					text: 'Generando PDF'
				};

				await presupuestosMX.budgetToInvoice(item);

				this.itemWorking = {
					id: null,
					text: ''
				};
			} else {
				this.$message.error('Ya existe otro proceso ejecutándose. Espera hasta que se complete.');
			}
		},
		async createPDF(item) {
			if (this.itemWorking.id === null) {
				this.itemWorking = {
					id: item._EntityId,
					text: 'Generando PDF'
				};

				await presupuestosMX.renderPDF(item);

				this.itemWorking = {
					id: null,
					text: ''
				};
			} else {
				this.$message.error('Ya existe otro proceso ejecutándose. Espera hasta que se complete.');
			}
		}
	}
};
</script>

<style lang="scss"></style>
